import React from 'react';
import { styled } from '@mui/system';
import AgentScreen from './NoOfAgentScreen';
import Summary from './Summary';
import Commission from './Commission';
import StateInterface from "../../../redux-magic/state-interface";
import { ObjectId } from "mongodb";
import Button from "@mui/material/Button";
import Notes from './Notes';
import SuccessScreen from './successScreen';
import { Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from "@mui/material/Dialog";
import { NextRouter } from "next/router";

// Container for the whole screen
const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column', // Ensure column layout
  alignItems: 'center',    // Center horizontally
  padding: 0,
  width: "100vw",
  minHeight: "100vh",
  margin: 0,
  backgroundSize: 'cover',
  position: 'relative',
  background: "#fff",
});

// Bottom buttons
const BottomBar = styled('div')({
  width: '100vw',
  maxWidth: 390,
  position: 'fixed',
  left: '50%',
  bottom: 0,
  transform: 'translateX(-50%)',
  background: '#fff',
  borderTop: '1px solid #F0F0F0',
  borderRadius: '24px 24px 0 0',
  boxShadow: '0 -2px 20px rgba(0,0,0,0.04)',
  padding: '16px 16px 24px 16px',
  display: 'flex',
  gap: '16px',
  justifyContent: 'space-between',
  zIndex: 10,
});

const OutlinedButton = styled(Button)({
  width: '358px',
  height: '40px',
  borderRadius: '16px',
  borderWidth: '1px',
  flex: 1,
  border: '2px solid #7B2323',
  background: '#fff',
  color: '#7B2323',
  fontSize: '18px',
});

const AppBarContainer = styled("div")({
  width: "100%",
  maxWidth: 390,
  height: 48,
  display: "flex",
  alignItems: "center",
  background: "#fff",
  borderBottom: "1px solid #F0F0F0",
  position: "fixed",
  top: 0,
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 1201,
  paddingLeft: 16,
  paddingRight: 8,
  boxSizing: "border-box",
  justifyContent: "space-between",
});

const TitleText = styled(Typography)({
  marginLeft: 16,
  fontWeight: 600,
});

const BackButton = styled(ArrowBackIcon)({
  color: "#0000008A",
 width: '20px',
  height: '20px',
})

const BackButtonContainer = styled("div")({
  display: "flex",
  alignItems: "center",
})

const CloseIconButton = styled(CloseIcon)({
  color: "#0000008A",
  width: '20px',
  height: '20px',
  cursor: 'pointer',
  marginRight: 8,
});

export default function NoOfAgentScreen(
  {
    dispatch,
    broadcast,
    transactionType,
    propertyId,
    business_profile_id,
    session,
    profile_context,
    propertyStatus,
    setOpen,
    open,
    router,
  }:
  {
      business_profile_id: string | ObjectId | undefined | null;
      dispatch: Function; 
      broadcast:  StateInterface["broadcast_data"] | undefined | null;
      transactionType: string;
      propertyId: ObjectId | string;
      session: StateInterface["redux_session"];
      profile_context: any;
      propertyStatus:string,
      setOpen: Function;
      open: boolean;
      router: NextRouter;
  }
) {
  const [page, setPage] = React.useState<string>('introduction');
  
  React.useEffect(() => {
      const handlePopState = (event: PopStateEvent) => {
        event.preventDefault();
        switch (page) {
          case 'commission':
            setPage('introduction');
            break;
          case 'notes': 
            setPage('commission');
            break;
          case 'broadcast':
            setPage('notes');
            break;
          case 'success':
            setPage('broadcast');
            break;
          default:
            break;
      }};
    
      window.addEventListener("popstate", handlePopState);
      return () => window.removeEventListener("popstate", handlePopState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router, dispatch]);

  type CompProps = {
    dispatch: Function;
    broadcast: StateInterface["broadcast_data"] | undefined | null;
    transactionType: string;
    propertyId: ObjectId | string;
    userId: string | ObjectId;
    business_profile_id: string | ObjectId | undefined | null;
    close: Function;
    setPage: Function;
    session: StateInterface["redux_session"];
    profile_context: any;
    propertyStatus: string;
  };
  
  let Comp: React.ComponentType<CompProps> = () => <></>;

  let ButtonLabel = ''
  let title = 'Agents';
  switch (page) {
    case 'introduction':
      Comp = AgentScreen;
      ButtonLabel = 'Select commission';
      title = 'Agents';
      break;
    case 'commission':
      Comp = Commission;
      ButtonLabel = 'Confirm';
      title = 'Commission';
      break;
      case 'notes':
        Comp = Notes;
        ButtonLabel = '';
        title = 'Notes';
        break;
    case 'broadcast':
      Comp = Summary;
      ButtonLabel = '';
      title = 'Broadcast';
      break;
    case 'success':
      Comp = SuccessScreen;
      ButtonLabel = '';
      title = 'Success';
      break;
    default:
      Comp = AgentScreen;
  }

  const handleClose = () => {
		setOpen(false);
	};
	

    const handleClick = () => {
      if (page === 'introduction') setPage('commission');
      else if (page === 'commission') setPage('notes');
    }

    const handleBack = () => {
      switch (page) {
        case 'commission':
          setPage('introduction');
          break;
        case 'notes': 
          setPage('commission');
          break;
        case 'broadcast':
          setPage('notes');
          break;
        case 'success':
          setPage('broadcast');
          break;
        default:
          break;
      }
    }
    
  return (
    <Dialog
        fullScreen
        open={Boolean(open)}
        sx={{
        "& .MuiDialog-paper": {
        borderRadius: "0",
        }
        }}
        onClose={handleClose}
    >
      <Container>
        <div style={{ height: 48, width: "100%" }} >
          <AppBarContainer>
            <BackButtonContainer>
              {!['introduction','success'].includes(page) && <BackButton onClick={handleBack}/>}
              <TitleText variant='body1'>{title}</TitleText>
            </BackButtonContainer>
            {page !== 'success' && <CloseIconButton onClick={handleClose}/>}
          </AppBarContainer>
          </div>
          <Comp
            propertyStatus={propertyStatus}
            close={handleClose}
            dispatch={dispatch}
            broadcast={broadcast}
            transactionType={transactionType}
            propertyId={propertyId}
            business_profile_id={business_profile_id}
            userId={profile_context.user_id}
            setPage={setPage}
            session={session}
            profile_context={profile_context}
          />
        {ButtonLabel && 
          <BottomBar>
            <OutlinedButton variant='outlined' onClick={handleClick}>{ButtonLabel}</OutlinedButton>
          </BottomBar>
        }
      </Container>
    </Dialog>
  );
}